import { render, staticRenderFns } from "./LoadingComp.vue?vue&type=template&id=10863e90&scoped=true"
import script from "./LoadingComp.vue?vue&type=script&lang=js"
export * from "./LoadingComp.vue?vue&type=script&lang=js"
import style0 from "./LoadingComp.vue?vue&type=style&index=0&id=10863e90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10863e90",
  null
  
)

export default component.exports